import React from 'react';

export const reportMenuConfig = [
  {
    path: '/report/vendor-hq',
    component: React.lazy(() => import('./reportVendorHQ')),
  },
  {
    path: '/report/vendorBranch',
    component: React.lazy(() => import('./reportVendorBranch')),
  },
];
